/* eslint-disable */ import { assertString, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalGrillComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'variant', true).withAlias('LynxProfessionalGrill').attach(memoEval((self)=>[
            self.variant
        ], (variant)=>({
            value: variant,
            options: [
                {
                    label: 'All Trident Burners',
                    value: 'AllTrident'
                },
                {
                    label: '1 Trident Burner & Rotisserie',
                    value: 'TridentAndRotisserie'
                },
                {
                    label: 'Rotisserie',
                    value: 'RotisserieOnly'
                }
            ]
        })), (state)=>{
        assertString(state.value);
        return {
            variant: state.value
        };
    })
];

//# sourceMappingURL=lynx-professional-grill.js.map